export default "{\n    \"subtitleText\": \"POUR LES RESTAURANTS\"\n}\n"